import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, watch } from 'vue';
    import ConfirmationModal from './ConfirmationModal.vue';
    import { useConfirmationStore } from '@/stores/confirmation.store';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'GlobalConfirmationContainer',
  setup(__props) {

    const confirmationStore = useConfirmationStore();
    const confirmationModalRef = ref<InstanceType<typeof ConfirmationModal> | null>(null);

    onMounted(() => {
        confirmationStore.init(confirmationModalRef);
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ConfirmationModal, {
    ref_key: "confirmationModalRef",
    ref: confirmationModalRef
  }, null, 512))
}
}

})